:host {
  position: relative;
  display: grid;
  flex: 1 0 50%;
  grid-template-rows: auto 1fr 70px;
  height: 100vh;
  height: 100dvh;
}

.vx-animated-multi-page-page__header {
  position: relative;
  margin-bottom: 30px;
  padding: 36px 16px 0;
}

.vx-animated-multi-page-page__content {
  padding: 0 16px;
  overflow-y: scroll;
}

.vx-animated-multi-page-page__footer {
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: end;
  width: 100%;
  padding: 0 16px 10px;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.05);
}